import Filter from "../../Components/common/Table/Components/FilterTable";
import {
  createValueListCell,
  LastSeenCell,
  MatchCountCell,
  YaraHostCell,
  YaraRuleCell,
} from "../../Pages/Agents/YaraResults/components/cells";
import {
  TransferDelayCell,
  TransferRelayCell,
  TransferStatusCell,
  TransferTextCell,
  TransferTimeCell,
} from "../../Pages/MailGateway/components/transferLogCells";
import Score from "../../Pages/AnalysisReports/Content/Tabs/Overview/components/Score";
import ProgressLine from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/ProgressLine";
import SeverityStatusWrapper from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/SeverityStatusWrapper";
import SeverityStatus2 from "../../Components/PagesComponents/Dashboard/DashBoardTable/Table/components/SeverityStatus";
import Os from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/OS";
import GroupCounter, {
  GroupCounter2,
} from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/GroupCounter";
import User from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/User";
import Vm from "../../Components/PagesComponents/RunningAnalysis/Vm";
import File from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/File";
import Sender from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/Sender";
// import Verdict from "../../Components/common/Cells/Verdict/Verdict";
import NetworkTraffic from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/NetworkTraffic";
import Status from "../../Components/common/Cells/Status/Status";
import Local from "../../Components/PagesComponents/Settings/BackupCells/Backup Location/Local";
import RemoteUrl from "../../Components/PagesComponents/Settings/BackupCells/Remote URL/RemoteUrl";
import FileNamePrefix from "../../Components/PagesComponents/Settings/BackupCells/FileName Prefix/FileNamePrefix";
import Encrypt from "../../Components/PagesComponents/Settings/BackupCells/Encrypt/Encrypt";
import Estimation from "../../Components/PagesComponents/Settings/BackupCells/Estimation/Estimation";
import Action from "../../Components/PagesComponents/Settings/BackupCells/Action/Action";
import Severity from "../../Pages/AnalysisReports/Content/Tabs/Overview/components/Severity";
import Recipient from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/Recipient";
import TabEvent from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/TabEvent";
import FilePath from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/FilePath";
import Time from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/Time";
import Senderimap from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/Senderimap";
import Id from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/Id";
import Server from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/Server";
import IntegrationAction from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/IntegrationAction";
import CompressedFileCount from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/CompressedFileCount";
import Categories from "../../Pages/AnalysisReports/Content/Tabs/Overview/components/Categories";
import Ttps from "../../Pages/AnalysisReports/Content/Tabs/Overview/components/Ttps";
import Favorite from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/Favorite";
import Type from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/Type";
import Secret from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/Secret";
import NetworkDetectionsSeverity from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/NetworkDetectionsSeverity";
import NetworkDetectionsTime from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/NetworkDetectionsTime";
import NetworkDetectionsUrl from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/NetworkDetectionsUrl";
import NetworkDetectionsAction from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/NetworkDetectionsAction";
import NetworkDetectionsClientIp from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/NetworkDetectionsClientIp";
import NetworkDetectionsServerIp from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/NetworkDetectionsServerIp";
import NetworkDetectionsFileName from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/NetworkDetectionsFileName";
import UrlsUrl from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/UrlsUrl";
import UrlsFileName from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/UrlsFileName";
import UrlsFileHash from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/UrlsFileHash";
import DomainsAndIpsDomain from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/DomainsAndIpsDomain";
import HostAndDomain from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/HostAndDomain";
import ThreeDots from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/ThreeDots";
import StaticResultsRunning from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/StaticResultsRunning";
import BlockedEmailsAction from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/BlockedEmailsAction";
import BlockedEmailsRelease from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/BlockedEmailsRelease";
import BlockedEmailsDate from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/BlockedEmailsDate";
import AnalyzedEmailsVerdict from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/AnalyzedEmailsVerdict";
import AutoCell from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/AutoCell";
import OSCloud from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/OSCloud";
import { HighlightedCell } from "../../Components/PagesComponents/AnalysisReports/AndroidPlugins/Components/HighlightedCell";
import { CellWithCopyButton } from "../../Components/common/ReactTableWrapper/Components/CellWithCopyButton";
import DoCdrTable from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/DoCdrTable";
import CdrDownload from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/CdrDownload";
import OnlineStatus from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/OnlineStatus";
import Verdict from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/Verdict";
import ThreatHunterTime from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/ThreatHunterTime";
import AgentInstallationThreeDots from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/AgentInstallationThreeDots";
import AgentScanStatusBadge from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/AgentScanStatusBadge";
import {
  AgentSelectAllCheckbox,
  AgentRowCheckbox,
} from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/AgentSelectionCheckbox";
import ThunterEngine from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/ThunterEngine";
import HashesHash from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/HashesHash";
import CheckWithAI from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/CheckWithAi";
import OsReportExport from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/OsReportExport";
import FsaCdrDownload from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/FsaCdrDownload";
import FsaHashes from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/FsaHashes";
import FsaThreeDots from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/FsaThreeDots";
import FsaAnalysisStatus from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/FsaAnalysisStatus";
import FsaStatusBadge from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/FsaStatusBadge";
import FsaDate from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/FsaDate";
import TableDate from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/TableDate";
import DynamicPhishingDecision from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/DynamicPhishingDecision";
import DynamicAllowDecision from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/DynamicAllowDecision";
import PhishBoxSubmit from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/PhishBoxSubmit";
import PhishBoxLink from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/PhishBoxLink";
import PhishBoxScreenshot from "../../Components/PagesComponents/Dashboard/DashBoardTable/components/PhishBoxScreenshot";
import UserIcon from "../../Components/Icon-SVG/UserIcon";

export const overview = [
  {
    Filter,
    Header: "Description",
    accessor: "description",
    className: "overview__table-block-description",
    sort: true,
  },
  {
    Filter,
    Cell: Categories,
    Header: "Categories",
    accessor: "categories",
    className: "overview__table-block-categories",
    sort: true,
  },
  {
    Filter,
    Cell: Ttps,
    Header: "Ttps",
    accessor: "ttp",
    className: "overview__table-block-ttps",
    sort: true,
  },
  {
    Filter,
    Cell: Severity,
    Header: "Severity",
    accessor: "severity",
    className: "overview__table-block-last-child",
    sort: true,
  },
  {
    Filter,
    Header: "Confidence",
    accessor: "confidence",
    className: "overview__table-block-last-child",
    sort: true,
  },
  {
    Filter,
    Header: "Weight",
    accessor: "weight",
    className: "overview__table-block-last-child",
    sort: true,
  },
];

export const overviewReport = [
  {
    Header: "Description",
    accessor: "description",
    className: "overview__table-block-description",
  },
  {
    Cell: Categories,
    Header: "Categories",
    accessor: "categories",
    className: "overview__table-block-categories",
  },
  {
    Cell: Ttps,
    Header: "Ttps",
    accessor: "ttp",
    className: "overview__table-block-ttps",
  },
  {
    Cell: Severity,
    Header: "Severity",
    accessor: "severity",
    className: "overview__table-block-last-child",
  },
  {
    Header: "Confidence",
    accessor: "confidence",
    className: "overview__table-block-last-child",
  },
  {
    Header: "Weight",
    accessor: "weight",
    className: "overview__table-block-last-child",
  },
];

export const crime = [
  {
    Filter,
    Header: "Description",
    accessor: "crime",
    className: "overview__table-block-description",
    sort: true,
  },
  {
    Filter,
    Cell: Severity,
    Header: "Score",
    accessor: "score",
    className: "overview__table-block-last-child",
    sort: true,
  },
  {
    Filter,
    Header: "Confidence",
    accessor: "confidence",
    className: "overview__table-block-last-child",
    sort: true,
  },
  {
    Filter,
    Header: "Weight",
    accessor: "weight",
    className: "overview__table-block-last-child",
    sort: true,
  },
];

export const staticCodeIssues = [
  {
    Filter,
    Header: "Description",
    accessor: "metadata.description",
    cellClassName: "react-table__word-break",
    sort: true,
  },
  {
    Filter,
    Header: "CWE",
    accessor: "metadata.cwe",
    cellClassName: "react-table__no-wrap",
    sort: true,
  },
  {
    Filter,
    Header: "MASVS",
    accessor: "metadata.masvs",
    cellClassName: "react-table__no-wrap",
    sort: true,
  },
  {
    Filter,
    Header: "Owasp Mobile",
    accessor: "metadata.owasp-mobile",
    cellClassName: "react-table__no-wrap",
    sort: true,
  },
  {
    Filter,
    Header: "Severity",
    accessor: "metadata.severity",
    cellClassName: "react-table__no-wrap",
    sort: true,
  },
];

export const permission = [
  {
    Filter,
    Header: "Name",
    accessor: "simplified_name",
    className: "overview__table-block-description",
    sort: true,
  },
  {
    Filter,
    Cell: Severity,
    Header: "Severity",
    accessor: "severity",
    className: "overview__table-block-last-child",
    sort: true,
  },
  {
    Filter,
    Header: "Tags",
    accessor: "tags",
    className: "overview__table-block-last-child",
    sort: true,
  },
  {
    Filter,
    Header: "Description",
    accessor: "description",
    className: "overview__table-block-last-child",
    sort: true,
  },
];

export const androidPluginLibrary = [
  {
    Filter,
    Header: "Date",
    accessor: "date",
    className: "",
    sort: true,
  },
  {
    Filter,
    Header: "Name",
    accessor: "name",
    className: "",
    sort: true,
  },
];

export const androidPluginDeletedFiles = [
  {
    Filter,
    Header: "Date",
    accessor: "date",
    className: "",
    sort: true,
  },
  {
    Filter,
    Cell: HighlightedCell,
    Header: "Method",
    accessor: "method",
    className: "",
    sort: true,
  },
  {
    Filter,
    Header: "Name",
    accessor: "name",
    className: "",
    sort: true,
  },
];

export const androidPluginFiles = [
  {
    Filter,
    Header: "Date",
    accessor: "date",
    className: "",
    sort: true,
  },
  {
    Filter,
    Cell: HighlightedCell,
    Header: "Method",
    accessor: "method",
    className: "",
    sort: true,
  },
  {
    Filter,
    Header: "Name",
    accessor: "name",
    className: "",
    sort: true,
  },
];

export const androidPluginSharedPreferences = [
  {
    Filter,
    Header: "Date",
    accessor: "date",
    className: "",
    sort: true,
  },
  {
    Filter,
    Cell: HighlightedCell,
    Header: "Method",
    accessor: "method",
    sort: true,
  },
  {
    Filter,
    Header: "File Path",
    accessor: "file_path",
    className: "",
    sort: true,
  },
  {
    Filter,
    Header: "Value",
    accessor: "value",
    className: "",
    sort: true,
  },
];

export const androidPluginLogs = [
  {
    Filter,
    Header: "Date",
    accessor: "date",
    className: "",
    sort: true,
  },
  {
    Filter,
    Cell: HighlightedCell,
    Header: "Method",
    accessor: "method",
    className: "",
    sort: true,
  },
  {
    Filter,
    Header: "Tag",
    accessor: "tag",
    className: "",
    sort: true,
  },
  {
    Filter,
    Header: "Message",
    accessor: "message",
    className: "",
    sort: true,
  },
];

export const snortsuricata = [
  {
    Filter,
    Header: "Source Ip",
    accessor: "srcIp",
    className: "snort-suricata__table-block-ip",
    rowClassName: "snort-suricata__table-cell-ip",
    sort: true,
  },

  {
    Filter,
    Header: "Destination IP",
    accessor: "destIp",
    className: "snort-suricata__table-block-ip",
    rowClassName: "snort-suricata__table-cell-ip",
    sort: true,
  },

  {
    Header: "Type",
    accessor: "protocol",
    className: "snort-suricata__table-block-protocol",
    rowClassName: "snort-suricata__table-cell-protocol",
    sort: true,
  },

  {
    Header: "CN",
    accessor: "country_code",
    className: "snort-suricata__table-block-protocol",
    rowClassName: "snort-suricata__table-cell-protocol",
    sort: true,
  },

  {
    Filter,
    Header: "Signature/Messages",
    accessor: "signature",
    className: "snort-suricata__table-block-signature",
    rowClassName: "snort-suricata__table-cell-signature",
    sort: true,
  },
];

// Same columns without Filter/sort, so the report and pdf get a plain table
export const snortsuricataReport = [
  {
    Header: "Source Ip",
    accessor: "srcIp",
    className: "snort-suricata__table-block-ip",
    rowClassName: "snort-suricata__table-cell-ip",
  },

  {
    Header: "Destination IP",
    accessor: "destIp",
    className: "snort-suricata__table-block-ip",
    rowClassName: "snort-suricata__table-cell-ip",
  },

  {
    Header: "Type",
    accessor: "protocol",
    className: "snort-suricata__table-block-protocol",
    rowClassName: "snort-suricata__table-cell-protocol",
  },

  {
    Header: "CN",
    accessor: "country_code",
    className: "snort-suricata__table-block-protocol",
    rowClassName: "snort-suricata__table-cell-protocol",
  },

  {
    Header: "Signature/Messages",
    accessor: "signature",
    className: "snort-suricata__table-block-signature",
    rowClassName: "snort-suricata__table-cell-signature",
  },
];

export const dashboardHeader = [
  {
    Cell: Favorite,
    accessor: "favorite",
  },
  // {
  //   event: "copy",
  //   accessor: "tab-event",
  //   Cell: TabEvent,
  // },
  {
    Filter,
    Header: "User",
    accessor: "user",
    rowClassName: "dashboard-table_user",
    Cell: User,
    sort: true,
  },
  {
    Header: "Submit Time / Type",
    accessor: "time.time",
    Cell: Time,
    sort: true,
  },
  {
    Filter,
    Header: "File Name / Hash / Type",
    accessor: "file.name",
    rowClassName: "dashboard-table_link",
    Cell: File,
    sort: true,
  },
  {
    Filter: false,
    Header: "Count",
    accessor: "compressedFileCount",
    Cell: CompressedFileCount,
    sort: false,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "groupCounter",
    Cell: GroupCounter2,
    sort: false,
  },
  {
    Filter: false,
    Cell: ProgressLine,
    Header: "Progress",
    accessor: "progress",
    sort: false,
  },
  {
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    sort: true,
  },
  {
    id: "staticResults",
    accessor: "staticResultLink",
    Cell: ThreeDots,
  },
];

export const documentsHeader = [
  {
    Cell: DoCdrTable,
    accessor: "favorite",
  },
  {
    Filter,
    Header: "User",
    accessor: "user",
    rowClassName: "dashboard-table_user",
    Cell: User,
    sort: true,
  },
  {
    Header: "Submit Time / Type",
    accessor: "time.time",
    Cell: Time,
    sort: true,
  },
  {
    Filter,
    Header: "File Name / Hash / Type",
    accessor: "file.name",
    rowClassName: "dashboard-table_link",
    Cell: File,
    sort: true,
  },
  {
    Filter: false,
    Header: "Count",
    accessor: "compressedFileCount",
    Cell: CompressedFileCount,
    sort: false,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "groupCounter",
    Cell: GroupCounter2,
    sort: false,
  },
  {
    Filter: false,
    Cell: ProgressLine,
    Header: "Progress",
    accessor: "progress",
    sort: false,
  },
  {
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    sort: true,
  },
  {
    id: "staticResults",
    accessor: "staticResultLink",
    Cell: ThreeDots,
  },
];

export const cdrHeader = [
  {
    Filter,
    Header: "User",
    accessor: "user",
    rowClassName: "dashboard-table_user",
    Cell: User,
    sort: true,
  },
  {
    Header: "Submit Time / Type",
    accessor: "time.time",
    Cell: Time,
    sort: true,
  },
  {
    Filter,
    Header: "File Name / Hash / Type",
    accessor: "file.name",
    rowClassName: "dashboard-table_link",
    Cell: File,
    sort: true,
  },
  {
    Filter: false,
    Header: "Count",
    accessor: "compressedFileCount",
    Cell: CompressedFileCount,
    sort: false,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "groupCounter",
    Cell: GroupCounter2,
    sort: false,
  },
  {
    Filter: false,
    Cell: ProgressLine,
    Header: "Progress",
    accessor: "progress",
    sort: false,
  },
  {
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    sort: true,
  },
  {
    accessor: "cdrDownload",
    Cell: CdrDownload,
  },
];

export const cloudSubmissionsHeader = [
  {
    Header: "Submit Time",
    accessor: "time.time",
    Cell: Time,
    sort: true,
  },
  {
    Filter,
    Header: "File Info",
    accessor: "file.name",
    rowClassName: "dashboard-table_link",
    Cell: File,
    sort: true,
  },
  {
    Filter: false,
    Header: "Count",
    accessor: "compressedFileCount",
    Cell: CompressedFileCount,
    sort: false,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "groupCounter",
    Cell: OSCloud,
    sort: false,
  },
  {
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    sort: true,
  },
];

export const latestProfileHeader = [
  {
    Header: "Submit Time",
    accessor: "time.time",
    Cell: Time,
    sort: true,
  },
  {
    Filter,
    Header: "File Info",
    accessor: "file.name",
    rowClassName: "dashboard-table_link",
    Cell: File,
    sort: true,
  },
  {
    Filter: false,
    Header: "Count",
    accessor: "compressedFileCount",
    Cell: CompressedFileCount,
    sort: false,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "groupCounter",
    Cell: OSCloud,
    sort: false,
  },
  {
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    sort: true,
  },
];

export const agentHeader = [
  {
    Header: "Submit Time",
    accessor: "time.time",
    Cell: Time,
    sort: true,
  },
  {
    Filter,
    Header: "File Name / Hash / Type",
    accessor: "file.name",
    rowClassName: "dashboard-table_link",
    Cell: File,
    sort: true,
  },
  {
    Filter,
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    sort: true,
  },
];

export const threatHunterSingleAgentAnalysisHeader = [
  {
    Filter,
    Header: "Client ID",
    accessor: "clientID",
    cellClassName: "standout-text",
    sort: false,
    Cell: ({ value }) => value || "Manual Install",
  },
  {
    Filter,
    Header: "Local IP",
    accessor: "localIp",
    sort: false,
  },
  {
    Filter,
    Header: "Reported At",
    accessor: "reportTime",
    Cell: ({ value }) => value || "-",
    sort: true,
  },
  {
    Filter: false,
    Cell: Verdict,
    Header: "Verdict",
    accessor: "verdict",
    cellClassName: "agent-installation__table__verdict",
    sort: false,
  },
];

export const maliciousDetectionsHeader = [
  {
    Filter,
    Header: "Date",
    accessor: "date",
    cellClassName: "date",
    sort: false,
  },
  {
    Filter,
    Header: "Hash",
    accessor: "hash",
    Cell: AutoCell,
    sort: false,
  },
  {
    Filter,
    Header: "File Name",
    accessor: "filename",
    cellClassName: "file-name",
    cellShowTitle: true,
    Cell: ({ value }) => value || "-",
    sort: true,
  },
  {
    Filter,
    Header: "Source",
    accessor: "source",
    Cell: ({ value }) => value || "-",
    sort: true,
  },
  {
    Filter: false,
    Header: "Verdict",
    accessor: "verdict",
    cellClassName: "agent-installation__table__verdict",
    Cell: ({ value }) => <div className="malicious">{value}</div>,
    sort: false,
  },
];

// export const threatHunterAllAgentsAnalysisHeader = [
//   {
//     Filter,
//     Header: "Client ID",
//     accessor: "_source.SystemInfo.cpuid",
//     sort: false,
//   },
//   {
//     Filter,
//     Header: "MAC Address",
//     accessor: "_source.SystemInfo.macaddress",
//     sort: false,
//   },
//   {
//     Filter,
//     Header: "Hostname",
//     accessor: "_source.SystemInfo.hostname",
//     sort: false,
//   },
//   {
//     Filter,
//     Header: "Time",
//     accessor: "@timestamp",
//     rowClassName: "threat-hunter__table__time",
//     Cell: ThreatHunterTime,
//     sort: true,
//   },
//   {
//     Filter: false,
//     Cell: Verdict,
//     Header: "Verdict",
//     accessor: "lastScanVerdict",
//     cellClassName: "agent-installation__table__verdict",
//     sort: false,
//   },
// ];

// export const threatHunterRegistries = [
//   {
//     Filter,
//     Header: "Data",
//     accessor: "data",
//     cellClassName: "threat-hunter__table__file-name",
//     sort: true,
//   },
//   {
//     Filter,
//     Header: "Name",
//     accessor: "name",
//     className: "overview__table-block-description",
//     sort: true,
//   },
//   {
//     Filter,
//     Header: "Path",
//     accessor: "path",
//     className: "overview__table-block-description",
//     sort: true,
//   },
//   {
//     Filter,
//     Header: "Time",
//     accessor: "time",
//     cellClassName: "threat-hunter__table__time",
//     sort: true,
//   },
// ];

export const threatHunterSecurityIssues = [
  {
    Filter,
    Header: "Issue",
    accessor: "issue",
    cellClassName: "threat-hunter__table__file-name",
  },
  {
    Filter,
    Header: "Description",
    accessor: "description",
    className: "overview__table-block-description",
  },
  {
    Filter,
    Header: "Severity",
    accessor: "severity",
    sort: true,
  },
];

export const threatHunterActiveMaliciousProcesses = [
  {
    Filter,
    Header: "Process Name",
    accessor: "process_name",
    cellClassName: "threat-hunter__table__file-name",
  },
  {
    Filter,
    Header: "Path",
    accessor: "process_path",
  },
  {
    Filter,
    Header: "Process ID",
    accessor: "process_id",
  },
  {
    Filter,
    Header: "Match Reason",
    accessor: "match_reason",
  },
];

export const thunterFiles = [
  {
    Header: "File Path",
    accessor: "file",
    headerClassName: "thunter-detection-details__cell--file",
    cellClassName: "thunter-detection-details__cell--file",
  },
  { Header: "Risk Score", accessor: "score" },
  {
    Header: "Engine",
    accessor: "engine",
    Cell: ThunterEngine,
  },
  { Header: "Signature", accessor: "signature_status", Cell: ({ value }) => value || "-" },
  {
    Header: "Reason",
    accessor: "reason",
    headerClassName: "thunter-detection-details__cell--reason",
    cellClassName: "thunter-detection-details__cell--reason",
  },
];

export const thunterProcesses = [
  {
    Header: "Process Name",
    accessor: "process",
    headerClassName: "thunter-detection-details__cell--process",
    cellClassName: "thunter-detection-details__cell--process",
  },
  { Header: "Risk Score", accessor: "score" },
  { Header: "Engine", accessor: "engine", Cell: ThunterEngine },
  { Header: "Signature", accessor: "signature_status", Cell: ({ value }) => value || "-" },
  {
    Header: "Reason",
    accessor: "reason",
    headerClassName: "thunter-detection-details__cell--reason",
    cellClassName: "thunter-detection-details__cell--reason",
  },
];

export const thunterHashes = [
  {
    Header: "Hash",
    accessor: "hash",
    headerClassName: "thunter-detection-details__cell--hash",
    cellClassName: "thunter-detection-details__cell--hash",
  },
  { Header: "Risk Score", accessor: "score" },
  { Header: "Engine", accessor: "engine", Cell: ThunterEngine },
  { Header: "File Path", accessor: "file_path", Cell: ({ value }) => value || "-" },
  {
    Header: "Reason",
    accessor: "reason",
    headerClassName: "thunter-detection-details__cell--reason",
    cellClassName: "thunter-detection-details__cell--reason",
  },
];

// export const threatHunterServices = [
//   {
//     Filter,
//     Header: "Name",
//     accessor: "name",
//     className: "overview__table-block-description",
//     sort: true,
//   },
//   {
//     Filter,
//     Header: "Path",
//     accessor: "path",
//     cellClassName: "threat-hunter__table__file-name",
//     sort: true,
//   },
//   {
//     Filter,
//     Header: "PID",
//     accessor: "pid",
//     className: "overview__table-block-description",
//     sort: true,
//   },
//   {
//     Filter,
//     Header: "Start Type",
//     accessor: "start_type",
//     className: "overview__table-block-description",
//     sort: true,
//   },
//   {
//     Filter,
//     Header: "Status",
//     accessor: "status",
//     className: "overview__table-block-description",
//     sort: true,
//   },
//   {
//     Filter,
//     Header: "User Account",
//     accessor: "user_account",
//     className: "overview__table-block-description",
//     sort: true,
//   },
// ];

// export const threatHunterYaraClamav = [
//   {
//     Filter,
//     Header: "Engine",
//     accessor: "engine",
//     className: "overview__table-block-description",
//     sort: true,
//   },
//   {
//     Filter,
//     Header: "File",
//     accessor: "file",
//     cellClassName: "threat-hunter__table__file-name",
//     sort: true,
//   },
//   {
//     Filter,
//     Header: "Threat",
//     accessor: "threat",
//     sort: true,
//   },
// ];

// Filtering and sorting live outside this table, in the Agent Installation
// toolbar, so the columns themselves carry neither Filter nor sort.
export const agentInstallationClientHeader = [
  {
    id: "selection",
    Header: AgentSelectAllCheckbox,
    Cell: AgentRowCheckbox,
    headerClassName: "agent-installation__table__selection",
    cellClassName: "agent-installation__table__selection",
  },
  {
    Header: "",
    accessor: "onlineStatus",
    Cell: OnlineStatus,
  },
  {
    Header: "Client ID",
    accessor: "clientID",
    Cell: ({ value }) => value || "Manual Install",
  },
  {
    Header: "Hostname",
    accessor: "hostname",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Username",
    accessor: "username",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "MAC Address",
    accessor: "macAddress",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Local IP",
    accessor: "localIp",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Created At",
    accessor: "createTime",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Last Seen At",
    accessor: "lastSeenDate",
    Cell: ({ value }) => (value && value !== "Error calculating time difference" ? value : "-"),
  },
  {
    Header: "Scan Status",
    accessor: "scanStatus",
    Cell: AgentScanStatusBadge,
  },
  {
    Header: "Yara Status",
    accessor: "yaraStatus",
    Cell: AgentScanStatusBadge,
  },
  // {
  //   Filter: false,
  //   Header: "Reformatted",
  //   accessor: "isReformatted",
  //   Cell: ({ value }) => (value === true ? "Yes" : value === false ? "No" : "-"),
  //   sort: true,
  // },
  {
    Cell: Verdict,
    Header: "Last Verdict",
    accessor: "lastScanVerdict",
    cellClassName: "agent-installation__table__verdict",
  },
  {
    id: "agentInstallationOptions",
    accessor: "agentInstallationOptions",
    Cell: AgentInstallationThreeDots,
  },
  // {
  //   id: "clientOptions",
  //   accessor: "clientOptions",
  //   Cell: ThreeDots,
  // },
];

export const fsaCdrListHeader = [
  {
    Filter,
    Header: "Source",
    headerClassName: "cdr__table__source",
    cellClassName: "cdr__table__source",
    accessor: "source",
    Cell: AutoCell,
  },
  {
    Filter,
    Header: "File Name",
    headerClassName: "cdr__table__file-name",
    cellClassName: "cdr__table__file-name",
    accessor: "original_file_name",
    Cell: AutoCell,
  },
  {
    Filter,
    Header: "Hash",
    accessor: "new_hash",
    Cell: FsaHashes,
    sort: false,
  },
  {
    Header: "Submitted / Completed",
    accessor: "create_time",
    Cell: FsaDate,
    sort: false,
  },
  {
    Header: "Duration",
    accessor: "duration",
    Cell: ({ value }) => <span style={{ whiteSpace: "nowrap" }}>{`${value.toFixed(1)} secs`}</span>,
    sort: false,
  },
  {
    Header: "Analysis Status",
    id: "fsaAnalysisStatus",
    accessor: "fsaAnalysisStatus",
    Cell: FsaAnalysisStatus,
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: FsaStatusBadge,
    sort: false,
  },
  // {
  //   accessor: "cdrDownload",
  //   Cell: FsaCdrDownload,
  // },
  {
    id: "fsaOptions",
    accessor: "fsaOptions",
    Cell: FsaThreeDots,
  },
];

export const listPopupHeader = [
  {
    Filter: false,
    Header: "Type",
    accessor: "file.name",
    Cell: Type,
    sort: false,
  },
  {
    Filter: false,
    Header: "Network Traffic",
    accessor: "networkTraffic",
    Cell: NetworkTraffic,
    sort: false,
  },
  {
    Filter: false,
    Header: "OS/R",
    accessor: "Os",
    rowClassName: "dashboard-table_os",
    Cell: OsReportExport,
    sort: false,
  },
  {
    Filter: false,
    Cell: CheckWithAI,
    Header: "AI",
    accessor: "checkWithAI",
    rowClassName: "dashboard-table_check-with-ai",
    sort: false,
  },
  {
    Filter: false,
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    rowClassName: "dashboard-table_severity",
    sort: false,
  },
];

export const statisticsHeader = [
  // {
  //   event: "copy",
  //   accessor: "tab-event",
  //   Cell: TabEvent,
  // },
  {
    Filter,
    Header: "User",
    accessor: "user",
    rowClassName: "dashboard-table_user",
    Cell: User,
    sort: true,
  },
  {
    Header: "Submit Time",
    accessor: "time",
    sort: true,
  },
  {
    Filter,
    Header: "File Name / Hash / Type",
    accessor: "file.name",
    cellClassName: "dashboard-table_link",
    Cell: File,
    sort: true,
  },
  {
    Filter: false,
    Header: "Submit Type",
    rowClassName: "dashboard-table_submit-type",
    accessor: "submitType",
    sort: false,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "Os",
    Cell: GroupCounter,
    sort: false,
  },
  {
    Filter: false,
    Cell: ProgressLine,
    Header: "Progress",
    accessor: "progress",
    sort: false,
  },
  {
    Filter,
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    sort: true,
  },
];

export const statisticsListPopupHeader = [
  {
    Filter: false,
    Header: "Type",
    accessor: "file.name",
    Cell: Type,
    sort: false,
  },
  {
    Filter: false,
    Header: "Network Traffic",
    accessor: "networkTraffic",
    Cell: NetworkTraffic,
    sort: false,
  },
  {
    Filter: false,
    Header: "OS",
    accessor: "Os",
    rowClassName: "dashboard-table_os",
    Cell: Os,
    sort: false,
  },
  {
    Filter: false,
    Cell: CheckWithAI,
    Header: "AI",
    accessor: "checkWithAI",
    rowClassName: "dashboard-table_check-with-ai",
    sort: false,
  },
  {
    Filter: false,
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    rowClassName: "dashboard-table_severity",
    sort: false,
  },
];

export const emailHeader = [
  // {
  //   event: "copy",
  //   accessor: "tab-event",
  //   Cell: TabEvent,
  // },
  {
    Filter,
    Header: "Sender",
    accessor: "sender",
    Cell: Sender,
    sort: true,
  },
  {
    Filter,
    Header: "Recipients",
    accessor: "recipients",
    Cell: Recipient,
    sort: true,
  },
  {
    Header: "Submit Time",
    accessor: "time",
    sort: true,
  },
  {
    Filter,
    Header: "File Name / Hash / Type",
    accessor: "file.name",
    rowClassName: "dashboard-table_link",
    Cell: File,
    sort: true,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "Os",
    Cell: GroupCounter,
    sort: false,
  },
  {
    Filter: false,
    Cell: ProgressLine,
    Header: "Reported Time",
    accessor: "Reported Time",
    sort: false,
  },
  {
    Filter,
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    sort: true,
  },
];

export const usbTransferHeader = [
  {
    Filter,
    Header: "USB Transfer Time",
    accessor: "time",
    sort: true,
  },
  {
    Filter: false,
    Header: "USB Name",
    accessor: "file.name",
    rowClassName: "dashboard-table_link",
    Cell: File,
    sort: true,
  },
  {
    Filter: false,
    Header: "OS",
    accessor: "oS",
    Cell: Os,
    sort: false,
  },
  {
    Filter,
    Cell: ProgressLine,
    Header: "Progress",
    accessor: "progress",
    sort: true,
  },
  {
    Filter,
    Cell: SeverityStatusWrapper,
    Header: "State",
    accessor: "severity",
    sort: true,
  },
];

export const imapEmailHeader = [
  // {
  //   event: "copy",
  //   accessor: "tab-event",
  //   Cell: TabEvent,
  // },
  {
    Header: "Sender",
    accessor: "sender.email",
    Cell: Senderimap,
    sort: true,
  },
  {
    Header: "Submit Time",
    accessor: "time",
    sort: true,
  },
  {
    Filter,
    Header: "File Name / Hash / Type",
    accessor: "file.name",
    rowClassName: "dashboard-table_link",
    Cell: File,
    sort: true,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "groupCounter",
    Cell: GroupCounter2,
    sort: false,
  },
  {
    Header: "Reported Time",
    accessor: "progress",
    sort: true,
  },
  {
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    sort: true,
  },
];

export const fileshareHeader = [
  // {
  //   event: "copy",
  //   accessor: "tab-event",
  //   Cell: TabEvent,
  // },
  {
    Header: "Full Path",
    accessor: "path",
    Cell: FilePath,
    sort: false,
  },
  {
    Header: "Submit Time",
    accessor: "time",
    sort: true,
  },
  {
    Filter,
    Header: "File Name / Hash / Type",
    accessor: "file.name",
    rowClassName: "dashboard-table_link",
    Cell: File,
    sort: true,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "groupCounter",
    Cell: GroupCounter2,
    sort: false,
  },
  {
    Header: "Reported Time",
    accessor: "progress",
    sort: true,
  },
  {
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    sort: true,
  },
];

export const proxyHeader = [
  // {
  //   event: "copy",
  //   accessor: "tab-event",
  //   Cell: TabEvent,
  // },
  {
    Header: "Client User",
    accessor: "sender.name",
    Cell: Sender,
    sort: true,
  },
  {
    Header: "Client IP",
    accessor: "path",
    Cell: FilePath,
    sort: true,
  },
  {
    Header: "Submit Time / Type",
    Cell: Time,
    accessor: "time",
    sort: true,
  },
  {
    Filter,
    Header: "File Name / Hash / Type",
    accessor: "file.name",
    rowClassName: "dashboard-table_link",
    Cell: File,
    sort: true,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "groupCounter",
    Cell: GroupCounter2,
    sort: false,
  },
  {
    Header: "Reported Time",
    accessor: "progress",
    sort: true,
  },
  {
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    sort: true,
  },
];

export const endpointHeader = [
  {
    Header: "Client User",
    accessor: "sender.name",
    Cell: Sender,
    sort: true,
  },
  {
    Header: "Hostname",
    accessor: "path",
    Cell: FilePath,
    sort: true,
  },
  {
    Header: "Submit Time",
    accessor: "time",
    sort: true,
  },
  {
    Filter,
    Header: "File Name / Hash / Type",
    accessor: "file.name",
    rowClassName: "dashboard-table_link",
    Cell: File,
    sort: true,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "groupCounter",
    Cell: GroupCounter2,
    sort: false,
  },
  {
    Filter: false,
    Cell: ProgressLine,
    Header: "Reported Time",
    accessor: "progress",
    sort: false,
  },
  {
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    sort: true,
  },
];

export const postfixEmailHeader = [
  // {
  //   event: "copy",
  //   accessor: "tab-event",
  //   Cell: TabEvent,
  // },
  {
    Header: "Sender",
    accessor: "sender.name",
    Cell: Sender,
    sort: true,
  },
  {
    Header: "Recipients",
    accessor: "recipients",
    Cell: Recipient,
    sort: true,
  },
  {
    Header: "Submit Time",
    accessor: "time",
    sort: true,
  },
  {
    Filter,
    Header: "File Name / Hash / Type",
    accessor: "file.name",
    rowClassName: "dashboard-table_link",
    Cell: File,
    sort: true,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "groupCounter",
    Cell: GroupCounter2,
    sort: false,
  },
  {
    Header: "Reported Time",
    accessor: "progress",
    sort: true,
  },
  {
    Filter,
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    sort: true,
  },
];

export const proxyPopupHeader = [
  {
    Filter: false,
    Header: "Type",
    accessor: "file.name",
    Cell: Type,
    sort: false,
  },
  {
    Filter: false,
    Header: "Network Traffic",
    accessor: "networkTraffic",
    Cell: NetworkTraffic,
    sort: false,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "Os",
    rowClassName: "dashboard-table_os",
    Cell: Os,
    sort: false,
  },
  {
    Filter: false,
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    rowClassName: "dashboard-table_severity",
    sort: false,
  },
];

export const endpointPopupHeader = [
  {
    Filter: false,
    Header: "Type",
    accessor: "file.name",
    Cell: Type,
    sort: false,
  },
  {
    Filter: false,
    Header: "Network Traffic",
    accessor: "networkTraffic",
    Cell: NetworkTraffic,
    sort: false,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "Os",
    rowClassName: "dashboard-table_os",
    Cell: Os,
    sort: false,
  },
  {
    Filter: false,
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    rowClassName: "dashboard-table_severity",
    sort: false,
  },
];

export const filesharePopupHeader = [
  {
    Filter: false,
    Header: "Type",
    accessor: "file.name",
    Cell: Type,
    sort: false,
  },
  {
    Filter: false,
    Header: "Network Traffic",
    accessor: "networkTraffic",
    Cell: NetworkTraffic,
    sort: false,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "Os",
    rowClassName: "dashboard-table_os",
    Cell: Os,
    sort: false,
  },
  {
    Filter: false,
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    rowClassName: "dashboard-table_severity",
    sort: false,
  },
];

export const emailPopupHeader = [
  {
    Filter: false,
    Header: "Type",
    accessor: "file.name",
    Cell: Type,
    sort: false,
  },
  {
    Filter: false,
    Header: "Network Traffic",
    accessor: "networkTraffic",
    Cell: NetworkTraffic,
    sort: false,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "Os",
    rowClassName: "dashboard-table_os",
    Cell: Os,
    sort: false,
  },
  {
    Filter: false,
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    rowClassName: "dashboard-table_severity",
    sort: false,
  },
];
export const postfixemailPopupHeader = [
  {
    Filter: false,
    Header: "Type",
    accessor: "file.name",
    Cell: Type,
    sort: false,
  },
  {
    Filter: false,
    Header: "Network Traffic",
    accessor: "networkTraffic",
    Cell: NetworkTraffic,
    sort: false,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "Os",
    rowClassName: "dashboard-table_os",
    Cell: Os,
    sort: false,
  },
  {
    Filter: false,
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    rowClassName: "dashboard-table_severity",
    sort: false,
  },
];

export const runningDashboardHeader = [
  {
    Filter,
    Header: "User",
    accessor: "user",
    Cell: User,
    rowClassName: "dashboard-table_user-run",
    sort: true,
  },
  {
    Header: "Submit Time / Type",
    accessor: "time.time",
    rowClassName: "dashboard-table_time-run",
    Cell: Time,
    sort: true,
  },
  {
    Header: <span style={{ display: "inline-block", width: "max-content" }}>S. Results</span>,
    accessor: "staticResultLink",
    rowClassName: "dashboard-table_static-run",
    Cell: StaticResultsRunning,
    sort: false,
  },
  {
    Filter,
    Header: "File Name",
    accessor: "file.name",
    rowClassName: "dashboard-table_link-run",
    Cell: File,
    sort: true,
  },
  {
    Filter: false,
    Header: "Count",
    accessor: "compressedFileCount",
    Cell: CompressedFileCount,
    sort: false,
  },
  {
    Filter: false,
    Header: "OS",
    accessor: "oS",
    Cell: Os,
    sort: false,
  },
  {
    Filter: false,
    Cell: ProgressLine,
    Header: "Progress",
    accessor: "progress",
    sort: false,
  },
  {
    Filter: false,
    Cell: SeverityStatusWrapper,
    Header: "Status",
    accessor: "severity",
    sort: false,
  },
];

export const runningPopupHeader = [
  {
    Filter: false,
    Header: "File Name",
    accessor: "file.name",
    rowClassName: "custom-table__running-popup__file-name",
    sort: false,
  },
  {
    Filter: false,
    Cell: ProgressLine,
    Header: "Progress",
    accessor: "progress",
    sort: false,
  },
  {
    Filter: false,
    Cell: SeverityStatusWrapper,
    Header: "State / Verdict",
    accessor: "severity",
    sort: false,
  },
];

export const runningHeader = [
  {
    Filter: false,
    Header: "File Name",
    accessor: "file",
    rowClassName: "dashboard-table_link",
    Cell: File,
    sort: true,
  },
  {
    Header: "Analyser",
    accessor: "Analyser",
    sort: true,
  },
  {
    Filter: false,
    Header: "VM Connection",
    accessor: "Vm",
    Cell: Vm,
    sort: true,
  },
  {
    Filter,
    Header: "Submit Time",
    accessor: "time",
    sort: true,
  },
  {
    Filter,
    Cell: SeverityStatusWrapper,
    Header: "Status",
    accessor: "severity",
    sort: true,
  },
];

export const dashboardMaliciousHeader = [
  // {
  //   event: "copy",
  //   accessor: "tab-event",
  //   Cell: TabEvent,
  // },
  {
    Filter,
    Header: "User",
    accessor: "user",
    rowClassName: "dashboard-table_user",
    Cell: User,
    sort: true,
  },
  {
    Header: "Submit Time / Type",
    accessor: "time.time",
    Cell: Time,
    sort: true,
  },
  {
    Filter,
    Header: "File Name / Hash / Type",
    accessor: "file.name",
    rowClassName: "dashboard-table_link",
    Cell: File,
    sort: true,
  },
  {
    Filter: false,
    Header: "Count",
    accessor: "compressedFileCount",
    Cell: CompressedFileCount,
    sort: false,
  },
  {
    Filter: false,
    Header: "Os",
    accessor: "groupCounter",
    Cell: GroupCounter2,
    sort: false,
  },
  {
    Cell: ProgressLine,
    Header: "Reported Time",
    accessor: "progress",
    sort: true,
  },
  {
    Filter: false,
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "severity",
    sort: false,
  },
];

export const droppedFileList = [
  {
    Filter,
    Header: "Type",
    accessor: "type",
    className: "dropped-files__table-block-type",
    sort: true,
  },
  {
    Filter,
    Header: "File Name",
    accessor: "value",
    className: "dropped-files__table-block-th",
    sort: true,
  },
  {
    Filter,
    Header: "Details Preview",
    accessor: "details",
    sort: true,
  },
  {
    Filter,
    Header: "YARA",
    accessor: "yara",
    className: "dropped-files__table-block-last-child",
    sort: true,
  },
  {
    Filter,
    Header: "VirusTotal",
    accessor: "virustotal",
    className: "dropped-files__table-block-last-child",
    sort: true,
  },
];

export const avYara = [
  {
    Filter,
    Header: "File type",
    accessor: "fileType",
    sort: true,
  },
  {
    Filter,
    Header: "Threat Name",
    accessor: "threatName",
    sort: true,
  },
  {
    Filter,
    Header: "File Name",
    accessor: "fileName",
    sort: true,
  },
  {
    Filter,
    Header: "Verdict",
    accessor: "verdict",
    sort: true,
    Cell: Verdict,
  },
  {
    Filter: false,
    Header: "Actions",
    accessor: "actions",
    sort: true,
  },
];

export const yaraMatchesHeader = [
  {
    Filter,
    Header: "Ruleset Name",
    accessor: "rulesetName",
    sort: true,
  },
  {
    Filter,
    Header: "Rule Name",
    accessor: "ruleName",
    sort: true,
  },
  {
    Filter,
    Header: "Rule Description",
    accessor: "ruleDescription",
    sort: true,
  },
  {
    Filter,
    Header: "File type",
    accessor: "fileType",
    sort: true,
  },
  {
    Filter,
    Header: "File Name",
    accessor: "fileName",
    sort: true,
  },
  {
    Filter,
    Header: "Classification",
    accessor: "classification",
    sort: true,
  },
  {
    Filter,
    Header: "Score",
    accessor: "score",
    Cell: Score,
    sort: true,
  },
  {
    Filter: false,
    Header: "Actions",
    accessor: "actions",
    sort: true,
  },
];

export const settingsYaraRules = [
  {
    Filter,
    Header: "Name",
    accessor: "name",
    sort: true,
  },
  {
    Filter,
    Header: "File type",
    accessor: "fileType",
    sort: true,
  },
  {
    Filter,
    Header: "Content type",
    accessor: "contentType",
    sort: true,
  },
  {
    Filter,
    Header: "Modification Time",
    accessor: "modificationTime",
    sort: true,
  },
  {
    Filter,
    Header: "Size",
    accessor: "size",
    sort: true,
  },
  {
    Filter,
    Header: "Delete",
    accessor: "delete",
    sort: true,
  },
];
export const settingsGuestImages = [
  {
    Filter: false,
    Header: "Image Name",
    accessor: "name",
    sort: true,
  },
  {
    Filter: false,
    Header: "Version",
    accessor: "version",
    sort: true,
  },
  {
    Filter: false,
    Header: "Type",
    accessor: "type",
    sort: true,
  },
  {
    Filter: false,
    Header: "Status",
    accessor: "status",
    Cell: Status,
    sort: true,
  },
  {
    Filter: false,
    Header: "Action",
    accessor: "action",
    sort: false,
  },
];

export const settingsBackup = [
  {
    Filter: false,
    Header: "Backup Profile",
    accessor: "profile",
    sort: false,
  },
  {
    Filter: false,
    Header: "Backup Location",
    accessor: "location",
    Cell: Local,
    sort: false,
  },
  {
    Filter: false,
    Header: "Remote URL or Server Location",
    accessor: "remote_url",
    sort: false,
    Cell: RemoteUrl,
  },
  {
    Filter: false,
    Header: "File Name Prefix",
    accessor: "file_name",
    sort: false,
    Cell: FileNamePrefix,
  },
  {
    Filter: false,
    Header: "Encrypt?",
    accessor: "encrypt",
    sort: false,
    Cell: Encrypt,
  },
  {
    Filter: false,
    Header: "Estimation Backup",
    accessor: "estimation",
    sort: false,
    Cell: Estimation,
  },
  {
    Filter: false,
    Header: "Action",
    accessor: "backup",
    sort: false,
    Cell: Action,
  },
];

export const settings_RSYSLOG = [
  {
    Filter: false,
    Header: "Name",
    accessor: "name",
    sort: false,
  },
  {
    Filter: false,
    Header: "Enabled",
    accessor: "enabled",
    sort: false,
  },
  {
    Filter: false,
    Header: "Ip Address",
    accessor: "ip",
    sort: false,
  },
  {
    Filter: false,
    Header: "Edit",
    accessor: "edit",
    sort: false,
  },
];

export const settings_SMTP_SNMP = [
  {
    Filter: false,
    Header: "Name",
    accessor: "name",
    sort: false,
  },
  {
    Filter: false,
    Header: "Enabled",
    accessor: "enabled",
    sort: false,
  },
  {
    Filter: false,
    Header: "Ip Address",
    accessor: "ip",
    sort: false,
  },
  {
    Filter: false,
    Header: "Community",
    accessor: "community",
    sort: false,
  },
  {
    Filter: false,
    Header: "Edit",
    accessor: "edit",
    sort: false,
  },
];

export const settings_HTTP = [
  {
    Filter: false,
    Header: "Name",
    accessor: "name",
    sort: false,
  },
  {
    Filter: false,
    Header: "Enabled",
    accessor: "enabled",
    sort: false,
  },
  {
    Filter: false,
    Header: "Server URL",
    accessor: "url",
    sort: false,
  },
  {
    Filter: false,
    Header: "Auth",
    accessor: "auth",
    sort: false,
  },
  {
    Filter: false,
    Header: "Alerts Update",
    accessor: "alerts",
    sort: false,
  },
  {
    Filter: false,
    Header: "SSL enable",
    accessor: "ssl_enable",
    sort: false,
  },
  {
    Filter: false,
    Header: "SSL Verify",
    accessor: "ssl_verify",
    sort: false,
  },
  {
    Filter: false,
    Header: "Edit",
    accessor: "edit",
    sort: false,
  },
];

export const compressedHeader = [
  {
    Filter,
    Header: "File Name / Hash / Type",
    accessor: "file.name",
    rowClassName: "dashboard-table_link",
    Cell: File,
    sort: false,
  },
  {
    Filter: false,
    Cell: CheckWithAI,
    Header: "AI",
    accessor: "ai",
    rowClassName: "dashboard-table_ai-row",
    sort: false,
  },
  {
    Filter: false,
    Cell: SeverityStatusWrapper,
    Header: "Verdict",
    accessor: "result",
    sort: false,
  },
];

export const compressedStaticResultsHeader = [
  {
    Filter,
    Header: "File Name / Hash / Type",
    accessor: "file.name",
    rowClassName: "dashboard-table_link",
    Cell: File,
    sort: false,
  },
  {
    Filter: false,
    Cell: (props) => <SeverityStatusWrapper {...props} statusType="staticPopup" />,
    Header: "Static Verdict",
    accessor: "result",
    sort: false,
  },
];

export const networkDetectionsHeader = [
  {
    Filter,
    Header: "Alert Type",
    accessor: "alertType",
    rowClassName: "network-detections__table__alert-type",
    sort: true,
  },
  {
    Filter,
    Header: "Time",
    accessor: "logger_time.$date",
    rowClassName: "network-detections__table__time",
    Cell: NetworkDetectionsTime,
    sort: true,
  },
  {
    Filter,
    Header: "User",
    accessor: "log.username",
    rowClassName: "network-detections__table__username",
    Cell: User,
    sort: true,
  },
  // {
  //   Filter,
  //   Header: "Severity",
  //   accessor: "severity",
  //   rowClassName: "network-detections__table__severity",
  //   Cell: NetworkDetectionsSeverity,
  //   sort: true,
  // },
  {
    Filter,
    Header: "Client IP",
    accessor: "log.clientIp",
    rowClassName: "network-detections__table__client-ip",
    Cell: NetworkDetectionsClientIp,
    sort: true,
  },
  {
    Filter,
    Header: "Server IP",
    accessor: "log.serverIp",
    rowClassName: "network-detections__table__server-ip",
    Cell: NetworkDetectionsServerIp,
    sort: true,
  },
  {
    Filter,
    Header: "File",
    accessor: "file_name",
    rowClassName: "network-detections__table__file-name",
    Cell: NetworkDetectionsFileName,
    sort: true,
  },
  {
    Filter,
    Header: "Url",
    accessor: "log.url",
    rowClassName: "network-detections__table__url",
    Cell: NetworkDetectionsUrl,
    sort: true,
  },
  {
    Filter,
    Header: "Action",
    accessor: "action",
    rowClassName: "network-detections__table__action",
    Cell: NetworkDetectionsAction,
    sort: true,
  },
];

export const urlsHeader = [
  {
    Filter,
    Header: "File Name",
    accessor: "file_name",
    rowClassName: "urls__table__file-name",
    Cell: UrlsFileName,
    sort: true,
  },
  {
    Filter,
    Header: "File Hash",
    accessor: "file_hash",
    rowClassName: "urls__table__file-hash",
    Cell: UrlsFileHash,
    sort: true,
  },
  {
    Filter,
    Header: "Report Date",
    accessor: "report_date",
    rowClassName: "urls__table__report-date",
    sort: true,
  },
  {
    Filter,
    Header: "Server IP",
    accessor: "server_ip",
    rowClassName: "urls__table__server-ip",
    sort: true,
  },
  {
    Filter,
    Header: "Url",
    accessor: "url",
    rowClassName: "urls__table__url",
    Cell: UrlsUrl,
    sort: true,
  },
];

export const domainsAndIpsHeader = [
  {
    Filter,
    Header: "File Name",
    accessor: "file_name",
    rowClassName: "domains__table__file-name",
    Cell: UrlsFileName,
    sort: true,
  },
  {
    Filter,
    Header: "File Hash",
    accessor: "file_hash",
    rowClassName: "domains__table__file-hash",
    Cell: UrlsFileHash,
    sort: true,
  },
  {
    Filter,
    Header: "Report Date",
    accessor: "report_date",
    rowClassName: "domains__table__report-date",
    sort: true,
  },
  {
    Filter,
    Header: "Server IP",
    accessor: "server_ip",
    rowClassName: "domains__table__server-ip",
    sort: true,
  },
  {
    Filter,
    Header: "Domain",
    accessor: "domain",
    rowClassName: "domains__table__domain",
    Cell: DomainsAndIpsDomain,
    sort: true,
  },
];

export const hashesHeader = [
  {
    Filter,
    Header: "File Name",
    accessor: "file_name",
    rowClassName: "hashes__table__file-name",
    Cell: UrlsFileName,
    sort: true,
  },
  {
    Filter,
    Header: "File Hash",
    accessor: "file_hash",
    rowClassName: "hashes__table__file-hash",
    Cell: UrlsFileHash,
    sort: true,
  },
  {
    Filter,
    Header: "Report Date",
    accessor: "report_date",
    rowClassName: "hashes__table__report-date",
    sort: true,
  },
  {
    Filter,
    Header: "Hash",
    accessor: "hash",
    rowClassName: "hashes__table__domain",
    Cell: HashesHash,
    sort: true,
  },
];

export const hostsAndDomains = [
  {
    Filter,
    Header: "Server IP",
    accessor: "server_ip",
    className: "hosts-and-domains__table__server-ip",
    sort: true,
  },
  {
    Filter,
    Header: "Host/Domain",
    accessor: "domain",
    className: "hosts-and-domains__table__domain",
    Cell: HostAndDomain,
    sort: true,
  },
  {
    Filter,
    Header: "Country Name",
    accessor: "country_name",
    className: "hosts-and-domains__table__country-name",
    sort: true,
  },
];

export const analyzedMailsHeader = [
  {
    Header: "Date",
    accessor: "date",
    rowClassName: "analyzed-emails__table__date",
  },
  {
    Filter,
    Header: "Sender",
    accessor: "sender",
    rowClassName: "analyzed-emails__table__sender",
    Cell: AutoCell,
  },
  {
    Filter,
    Header: "Recipient(s)",
    accessor: "recipients",
    rowClassName: "analyzed-emails__table__recipients",
    Cell: AutoCell,
  },
  {
    Filter,
    Header: "Subject",
    accessor: "subject",
    rowClassName: "analyzed-emails__table__subject",
    Cell: AutoCell,
  },
  {
    Header: "Verdict",
    accessor: "verdict",
    rowClassName: "analyzed-emails__table__verdict",
    Cell: AnalyzedEmailsVerdict,
  },
];

export const blockedMailsHeader = [
  {
    Header: "Queue ID",
    accessor: "email_id",
    rowClassName: "blocked-emails__table__email_id",
  },
  {
    Header: "Date",
    accessor: "date.$date",
    rowClassName: "blocked-emails__table__date",
    Cell: BlockedEmailsDate,
  },
  {
    Filter,
    Header: "Sender",
    accessor: "sender",
    rowClassName: "blocked-emails__table__sender",
    Cell: AutoCell,
  },
  {
    Filter,
    Header: "Recipient(s)",
    accessor: "recipients",
    rowClassName: "blocked-emails__table__recipients",
    Cell: AutoCell,
  },
  {
    Filter,
    Header: "Subject",
    accessor: "subject",
    rowClassName: "blocked-emails__table__subject",
    Cell: AutoCell,
  },
  {
    Header: "Action",
    accessor: "action",
    rowClassName: "blocked-emails__table__action",
    Cell: BlockedEmailsAction,
  },
  {
    Filter,
    Header: "Reason",
    accessor: "reason",
    rowClassName: "blocked-emails__table__reason",
    Cell: AutoCell,
  },
  {
    Header: "Release",
    accessor: "release",
    rowClassName: "blocked-emails__table__release",
    Cell: BlockedEmailsRelease,
  },
];

export const unblockedMailsHeader = [
  {
    Header: "Queue ID",
    accessor: "email_id",
    rowClassName: "unblocked-emails__table__email_id",
  },
  {
    Header: "Date",
    accessor: "date.$date",
    rowClassName: "unblocked-emails__table__date",
    Cell: BlockedEmailsDate,
  },
  {
    Filter,
    Header: "Sender",
    accessor: "sender",
    rowClassName: "unblocked-emails__table__sender",
    Cell: AutoCell,
  },
  {
    Filter,
    Header: "Recipient(s)",
    accessor: "recipients",
    rowClassName: "unblocked-emails__table__recipients",
    Cell: AutoCell,
  },
  {
    Filter,
    Header: "Subject",
    accessor: "subject",
    rowClassName: "unblocked-emails__table__subject",
    Cell: AutoCell,
  },
  {
    Filter,
    Header: "Reason",
    accessor: "reason",
    rowClassName: "unblocked-emails__table__reason",
    Cell: AutoCell,
  },
];

export const dynamicPhishingHeader = [
  {
    Header: "Date",
    accessor: "_source.time",
    rowClassName: "dynamic-phishing-emails__table__date",
    Cell: TableDate,
  },
  {
    Filter,
    Header: "Link",
    accessor: "_source.target_url",
    rowClassName: "dynamic-phishing-emails__table__link",
    Cell: PhishBoxLink,
  },
  {
    Filter,
    Header: "Recipient(s)",
    accessor: "_source.user",
    rowClassName: "dynamic-phishing-emails__table__recipients",
    Cell: AutoCell,
  },
  {
    Filter,
    Header: "Decision",
    accessor: "_source.decision",
    rowClassName: "",
    Cell: DynamicPhishingDecision,
  },
  {
    Header: "Screenshot",
    accessor: "system",
    rowClassName: "",
    Cell: PhishBoxScreenshot,
  },
  {
    Filter,
    Header: "Visited",
    accessor: "_source.visited",
    rowClassName: "",
    Cell: DynamicAllowDecision,
  },
];

export const phishBoxHeader = [
  {
    Filter,
    Header: "User",
    accessor: "user",
    rowClassName: "",
    Cell: AutoCell,
  },
  {
    Header: "Submit Time / Type",
    accessor: "date",
    rowClassName: "phishbox__table__date",
    Cell: PhishBoxSubmit,
  },
  {
    Filter,
    Header: "Link",
    accessor: "link",
    rowClassName: "phishbox__table__link",
    Cell: PhishBoxLink,
  },
  {
    Filter,
    Header: "Decision",
    accessor: "decision",
    rowClassName: "",
    Cell: DynamicPhishingDecision,
  },
  {
    Header: "Screenshot",
    accessor: "system",
    rowClassName: "",
    Cell: PhishBoxScreenshot,
  },
  {
    Filter,
    Header: "Visited",
    accessor: "visited",
    rowClassName: "",
    Cell: DynamicAllowDecision,
  },
];

export const hunterBoxHeader = [
  {
    Filter,
    Header: "Submit User",
    accessor: "submit_username",
    Cell: ({ value }) => (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <UserIcon width={13} height={13} color="var(--text-color-card)" />
        <span>{value || "-"}</span>
      </div>
    ),
  },
  {
    Header: "Client ID",
    accessor: "uid",
    Cell: ({ value }) => value,
  },
  {
    Header: "Report/Submit Time",
    accessor: "report_time",
    Cell: PhishBoxSubmit,
  },
  {
    Filter,
    Header: "Hostname",
    accessor: "host_name",
    Cell: ({ value }) => value || "-",
  },
  {
    Filter,
    Header: "Username",
    accessor: "username",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "MAC Address",
    accessor: "mac_address",
    Cell: ({ value }) => value || "-",
  },
  {
    Filter,
    Header: "Local IP",
    accessor: "local_ip",
    Cell: ({ value }) => value || "-",
  },
  {
    Cell: Verdict,
    Header: "Verdict",
    accessor: "decision",
    cellClassName: "hunterbox__table__verdict",
  },
];

// Yara Results tables: one row per group, the rest of the detail lives in the
// expanded row (see YaraMatchesDetail).
export const yaraResultsByRuleHeader = [
  {
    Filter,
    Header: "Rule",
    accessor: "yara_rule",
    Cell: YaraRuleCell,
  },
  {
    Header: "Hostnames",
    accessor: "hostnames_text",
    Cell: createValueListCell("hostnames", "host_count"),
  },
  {
    Header: "File Names",
    accessor: "file_names_text",
    Cell: createValueListCell("file_names", "file_count"),
  },
  {
    Header: "Matches",
    accessor: "match_count",
    Cell: MatchCountCell,
  },
  {
    Header: "Last Seen",
    accessor: "last_seen",
    Cell: LastSeenCell,
  },
];

export const yaraResultsByHostHeader = [
  {
    Filter,
    Header: "Hostname",
    accessor: "hostname",
    Cell: YaraHostCell,
  },
  {
    Header: "Rules",
    accessor: "yara_rules_text",
    Cell: createValueListCell("yara_rules", "rule_count"),
  },
  {
    Header: "File Names",
    accessor: "file_names_text",
    Cell: createValueListCell("file_names", "file_count"),
  },
  {
    Header: "Matches",
    accessor: "match_count",
    Cell: MatchCountCell,
  },
  {
    Header: "Last Seen",
    accessor: "last_seen",
    Cell: LastSeenCell,
  },
];

export const threatReportsHeader = [
  {
    Header: "Client ID",
    accessor: "uid",
    Cell: ({ value }) => value,
  },
  {
    Header: "Report Time / Submit Type",
    accessor: "report_time",
    Cell: PhishBoxSubmit,
  },
  {
    Filter,
    Header: "Hostname",
    accessor: "host_name",
    Cell: ({ value }) => value || "-",
  },
  {
    Filter,
    Header: "Username",
    accessor: "username",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "MAC Address",
    accessor: "mac_address",
    Cell: ({ value }) => value || "-",
  },
  {
    Filter,
    Header: "Local IP",
    accessor: "local_ip",
    Cell: ({ value }) => value || "-",
  },
  {
    Cell: Verdict,
    Header: "Verdict",
    accessor: "decision",
    cellClassName: "hunterbox__table__verdict",
  },
];

// Accessors double as the transfer-logs API's column search args
export const mailTransferLogsHeader = [
  {
    Header: "Queued At",
    accessor: "date",
    Cell: TransferTimeCell,
    headerClassName: "mgw-transfer__col--time",
  },
  {
    Filter,
    Header: "Sender",
    accessor: "from_address",
    Cell: TransferTextCell,
  },
  {
    Filter,
    Header: "Recipient",
    accessor: "to_address",
    Cell: TransferTextCell,
  },
  {
    Filter,
    Header: "Subject",
    accessor: "subject",
    Cell: TransferTextCell,
  },
  {
    Filter,
    Header: "Status",
    accessor: "status",
    Cell: TransferStatusCell,
    headerClassName: "mgw-transfer__col--status",
  },
  {
    Filter,
    Header: "Next Hop",
    accessor: "relay",
    Cell: TransferRelayCell,
  },
  {
    Header: "Delay",
    accessor: "delay",
    Cell: TransferDelayCell,
    headerClassName: "mgw-transfer__col--delay",
  },
  {
    Filter,
    Header: "Queue ID",
    accessor: "queue_id",
    Cell: TransferTextCell,
    headerClassName: "mgw-transfer__col--queue",
  },
];
